export default __webpack_public_path__ + "static/media/Flag_of_Lesotho.c2ec9883.svg";